import { IOptions } from '../apps/manage/interface/'
import {
  api_get,
  api_post,
  single_get,
  single_post,
  stringfy_post,
  single_stringfy_post
} from '../utils/http'

const PREFIX = '/cguardian/api'

// 任务总览 / 未分配资源
interface unassignOptions extends IOptions {
  subject_id: number
  business_type: number
  start_at: string
  end_at: string
}
async function getUnassignOverview(options: unassignOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-unassign-overview`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item, index) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 任务总览 / 处理中任务 / 查询
interface assignOverviewOptions extends IOptions {
  subject_id: number
  business_type: number
  start_at: string
  end_at: string
  check_at: string
  check_end: string
}
async function getAssignOverview(options: assignOverviewOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-assign-overview`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item, index) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 任务总览 / 资源审核时效 / 查询
interface deadlineOptions extends IOptions {
  subject_id: number
  business_type: number
  created_start: string
  created_end: string
}
async function getResourceDeadline(options: deadlineOptions) {
  const res = await api_post(`${PREFIX}/resource/get-resource-deadline`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 任务查询 / 处理中任务 / 查询
interface taskListOptions extends IOptions {
  subject_id: number
  process_type: string
  start_at: string
  end_at: string
  task_id: string
  business_type: number
  task_name: string
  user_id: string
}
async function getTaskList(options: taskListOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-task-list`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item, index) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 任务查询 / 未分配资源 / 查询
interface toDoListOptions extends IOptions {
  subject_id: number
  start_at: string
  end_at: string
  resource_id: string
  business_type: number
  tag: string
  status: string
}
async function getTodoTaskList(options: toDoListOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-todo-task-list`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item, index) => {
      return {
        index: index + 1,
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

function fetchJzdxTopics(topic_name: string) {
  return api_post(`${PREFIX}/resource/get-topics`, { business_type: 6001, topic_name }).then(
    (retData: { data: { doc_id: string; doc_text: string }[] }) => {
      return retData.data
    }
  )
}

// 任务查询 / 已完成任务 / 查询
interface finishTaskOptions extends IOptions {
  task_id: string
  task_name: string
  subject_id: number
  business_type: number
  process_type: string
  created_start: string
  created_end: string
  finish_at: string
  finish_end: string
  user_id: string
}
async function getFinishTask(options: finishTaskOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-finish-task`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 任务查询 / 已删除任务 / 查询
interface DeletedTaskOptions extends IOptions {
  resource_id?: string
  subject_id?: number
  business_type?: number
  start_at?: string
  end_at?: string
  status?: string
  category?: any
}
async function getDeletedResource(options: DeletedTaskOptions) {
  const res = await single_post(`${PREFIX}/workflow/task/get-deleted-resource`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 获取当前登录用户信息
async function getCurrentUserInfo() {
  const res = await api_get('/cguardian/api/users/get-user-info', {})
  const { data, success } = res
  if (success) {
    return data
  }
}

// 任务查询 / 任务分配
interface startOptions {
  instance_name: string
  user_id: string
  business_type: number
  subject_id: number
  put_start_time: string
  put_end_time: string
  handler_user_ids: string[]
  tag: string
  resource_amount: number
  email: string
  status: string
  valid_time: number
}
async function startWorkflow(options: startOptions) {
  const res = await stringfy_post(`${PREFIX}/workflow/instance/start-workflow`, options)
  return res
}

// queryUserList
interface userListOptions {
  page: number
  page_size: number
  name: string
  all: number
}
async function queryUserListWithGroup(options: userListOptions) {
  const res = await api_get('/cguardian/api/users/query-user-list', options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        label: item.username,
        value: item.id
      }
    })
  }
  return list
}

// 任务查询 / 处理中的任务 / 子任务查询
interface subTaskOptions {
  parent_id: string
  resource_id?: string
  subject_id?: number
  sample_type?: number
  sensitive_type?: number
  only_finished?: number
  process_type?: string
  status?: string
  page_num?: number
  page_size?: number
  check_at?: string
  check_end?: string
  tag: string
}
async function getSubTask(options: subTaskOptions) {
  const res = await api_post(`${PREFIX}/workflow/task/get-sub-task`, options)
  const { data, success } = res
  let list = []
  let total = 0
  if (success) {
    list = data.contents.map((item, index) => {
      return {
        key: String(index + 1),
        hasRetrieved: false,
        ...item
      }
    })
    total = data.count ? data.count : 0
  }
  return { list, total }
}

// 工作量统计 / 查询
interface statsOptions {
  user_name: string
  start_time: string
  end_time: string
}
async function getWorkStats(options: statsOptions) {
  const res = await api_post(`${PREFIX}/workflow/stats/get-work-stats`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data.map((item, index) => {
      return {
        key: index,
        ...item
      }
    })
  }
  return list
}

// 获取某个组的用户
interface IGroupUserOptions {
  status: string
  process_id?: string
}
async function queryGroupUser(options: IGroupUserOptions) {
  const res = await api_post(`${PREFIX}/users/query-group-user`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data
  }
  return list
}

// 批量通过
interface passOptions {
  business_type: number
  subject_id: number
  put_start_time: string
  put_end_time: string
  tag: string
  email: string
  status: string
}
async function batchDirectPass(options: passOptions) {
  const res = await stringfy_post(`${PREFIX}/resource/batch-direct-pass`, options)
  return res
}

// 批量终止
async function batchTerminate(options) {
  await stringfy_post(`${PREFIX}/workflow/instance/batch-terminate`, options)
}

// 撤回任务
interface retrieveTaskOptions {
  user_id: string
  instance_id: string
}
async function retrieveTask(options: retrieveTaskOptions) {
  await api_post(`${PREFIX}/workflow/instance/retrieve-task`, options)
}

// 获取待分配资源总数
interface DistributeResource {
  business_type?: number
  subject_id?: number
  status?: string
  put_start_time?: string
  put_end_time?: string
  tag?: string
  topic_id?: string
  category?: string | undefined
}

async function getDistributeResource(options: DistributeResource) {
  const res = await single_get(`${PREFIX}/workflow/instance/get_distribute_resource`, options)
  const { data, success } = res
  if (success) {
    return data
  } else {
    return ''
  }
}

// 任务转办
interface Transfer {
  transfer_to_user_id?: string
  instance_ids?: string[]
}

async function batchTransfer(options: Transfer) {
  const res = await single_stringfy_post(`${PREFIX}/workflow/instance/batch-transfer`, options)
  return res
}

export {
  queryUserListWithGroup,
  getCurrentUserInfo,
  getUnassignOverview,
  getResourceDeadline,
  getTaskList,
  getTodoTaskList,
  startWorkflow,
  getFinishTask,
  getDeletedResource,
  getAssignOverview,
  getSubTask,
  getWorkStats,
  queryGroupUser,
  batchDirectPass,
  batchTerminate,
  retrieveTask,
  fetchJzdxTopics,
  getDistributeResource,
  batchTransfer
}
